module.exports = __webpack_public_path__ + "img/Expo-Kc-6-month-Business.d3b03725.png";